import styled from '@emotion/styled';

import { FormInput } from '../../../UI/Form/FormInput/FormInput';

export const StyledFormInput = styled(FormInput)`
  max-width: 15.4375rem;
`;
